import { CreatorCriteoF } from './module/CreatorCriteoF.js';

export const viewHome = () => {
  if (window.criteo_q && T.lang == 'kr')
    window.criteo_q.push(...CreatorCriteoF.eventSet({ event: 'viewHome' }));
};
